<template>
    <div>
        Please Wait...
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: "AuthHandler",
    methods: mapActions(['exchangeToken']),
    created() {
        this.exchangeToken(window.location)
    }
}
</script>
